<template>
  <v-card class="pa-4">
    <h3 class="text-center">
      <strong>Padrões de Segurança Elétrica</strong>
    </h3>
    <v-divider class="my-4 mx-2"></v-divider>

    <v-tabs
      :height="40"
      :mobile-break-point="360"
      v-model="tab"
      class="ma-0"
      icons-and-text
      touchless
    >
      <v-tabs-slider color="#BBCF20"></v-tabs-slider>
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
        {{ $t('Solicitações recebidas') }}
      </v-tab>
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
        {{ $t('Solicitações feitas') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <receivedRequestsTable />
      </v-tab-item>
      <v-tab-item>
        <madeRequestsTable />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import madeRequestsTable from './madeRequestsTable.vue'
import receivedRequestsTable from './receivedRequestsTable.vue'

export default {
  name: 'RequestsModal',

  data() {
    return {
      tab: 0,
    }
  },

  components: {
    madeRequestsTable,
    receivedRequestsTable,
  },
}
</script>

<style></style>
